module.exports = __webpack_public_path__ + "8360edd49fefa0e80346a333ec2a0be1.png";